import React from 'react';
import useTranslation from 'next-translate/useTranslation';
import loadNamespaces from 'next-translate/loadNamespaces';
import { useIsMobile } from '../../style/constants';
import { Container } from '../../VuexyDesign/atoms/_index';
import FAQ from '../../components/HowItWorks/FAQ';
import HowToUploadHeroSection from '../../components/HowItWorks/HowToUploadHeroSection';
import BrowserPageTitle from '../../components/common/BrowserPageTitle';
import {
  HowItWorksRowDesktop,
  HowItWorksRowMobile,
} from '../../VuexyDesign/organisms/_index';
import { howToUpload } from '../../components/HowItWorks/AccordionContent';
import { VirpPageContext } from '../_app';

const howTos = [
  {
    key: 1,
    headerTitle: 'howItWorks:howToUploadPage.headerTitle.upload',
    title: 'howItWorks:howToUploadPage.chooseFile',
    subtitle: 'howItWorks:howToUploadDescriptions.uploadFile',
    media: '/static/animations/uploading.json',
    leftColumn: '7',
    rightColumn: '5',
    picture: true,
    videoLeft: false,
  },
  {
    key: 2,
    headerTitle: 'howItWorks:howToUploadPage.headerTitle.selectASnippet',
    title: 'howItWorks:howToUploadPage.selectTime',
    subtitle: 'howItWorks:howToUploadDescriptions.selectBestSeconds',
    media: '/static/animations/audiotrimming.json',
    leftColumn: '6',
    rightColumn: '5',
    picture: true,
    videoLeft: true,
  },
  {
    key: 3,
    headerTitle: 'howItWorks:howToUploadPage.headerTitle.addDetails',
    title: 'howItWorks:howToUploadPage.addInformation',
    subtitle: 'howItWorks:howToUploadDescriptions.addInformation',
    media: '/static/animations/addinfo.json',
    leftColumn: '7',
    rightColumn: '5',
    picture: true,
    videoLeft: false,
  },
  {
    key: 4,
    headerTitle: 'howItWorks:howToUploadPage.headerTitle.privacy',
    title: 'howItWorks:howToUploadPage.selectPrivacy',
    subtitle: 'howItWorks:howToUploadDescriptions.visibility',
    media: '/static/animations/share.json',
    leftColumn: '6',
    rightColumn: '5',
    picture: true,
    videoLeft: true,
  },
  {
    key: 5,
    headerTitle: 'howItWorks:howToUploadPage.headerTitle.safety',
    title: 'howItWorks:howToUploadPage.ownership',
    subtitle: 'howItWorks:howToUploadDescriptions.recieveOwnership',
    media: '/static/animations/ownership.json',
    leftColumn: '7',
    rightColumn: '5',
    picture: true,
    videoLeft: false,
  },
];

const Index = () => {
  const { t } = useTranslation('howItWorks');
  const isMobile = useIsMobile();

  return (
    <div className="d-flex w-100 justify-content-center align-items-center flex-column">
      <BrowserPageTitle>{t('howItWorks:howToUpload')}</BrowserPageTitle>
      <Container
        fluid
        className="d-flex align-items-center position-relative px-0"
      >
        <HowToUploadHeroSection />
      </Container>
      {howTos.map((howTo) =>
        isMobile ? (
          <HowItWorksRowMobile
            key={howTo.key}
            headerTitle={howTo.headerTitle}
            title={howTo.title}
            subtitle={howTo.subtitle}
            media={howTo.media}
            picture={howTo.picture}
          />
        ) : (
          <HowItWorksRowDesktop
            key={howTo.key}
            headerTitle={howTo.headerTitle}
            title={howTo.title}
            subtitle={howTo.subtitle}
            media={howTo.media}
            leftColumn={howTo.leftColumn}
            rightColumn={howTo.rightColumn}
            videoLeft={howTo.videoLeft}
            picture={howTo.picture}
          />
        ),
      )}
      <FAQ page={howToUpload} />
    </div>
  );
};

Index.getInitialProps = async (ctx: VirpPageContext) => {
  const getTranslations = await loadNamespaces({
    ...ctx,
    pathname: '/how-it-works/how-to-upload',
  });
  return { ...getTranslations };
};

export default Index;
